import React, { ReactNode, FunctionComponent } from 'react';

import { SupportedLanguage } from 'lib/lexemes/supported-languages';

type Props = {
  children?: ReactNode | string;
  lang?: SupportedLanguage;
};

const FeatureCtaHeader: FunctionComponent<Props> = ({ children, lang }) => {
  return (
    <h2 className="page-feature-cta__header" lang={lang}>
      {children}
    </h2>
  );
};

export default FeatureCtaHeader;
